import cloneDeep from 'lodash/cloneDeep';

import { Table, TableCell, TableRow } from './table.constants';

export function createTableRow(cells: TableCell[]): TableRow {
  return {
    cells: cells.map(c => ({
      value: {},
      __typename: 'TableComponentCell',
    })),
    __typename: 'TableComponentRow',
  };
}

export function removeRow(table: Table, rowIndex: number) {
  const updatedTableData = cloneDeep(table);
  updatedTableData.rows.splice(rowIndex, 1);
  return updatedTableData;
}

export function addBelow(table: Table, rowIndex: number) {
  const updatedTableData = cloneDeep(table);
  const currentRow = updatedTableData.rows[rowIndex];
  updatedTableData.rows.splice(
    rowIndex + 1,
    0,
    createTableRow(currentRow.cells)
  );
  return updatedTableData;
}

export function addAbove(table: Table, rowIndex: number) {
  const updatedTableData = cloneDeep(table);
  const newRow = createTableRow(updatedTableData.rows[rowIndex].cells);
  updatedTableData.rows.splice(rowIndex, 0, newRow);
  return updatedTableData;
}

export function canShowRemoveRow(rows: TableRow[]) {
  return rows.length > 1;
}
